import React from "react";
import { twMerge } from "tailwind-merge";
const Header = ({ showWeekPicker, className, }) => (React.createElement("div", { className: twMerge("typography-small flex items-center justify-between py-1 text-placeholder-color", className), "data-cy": "ukt-calendar-header", "aria-hidden": "true" },
    showWeekPicker && React.createElement("div", null),
    React.createElement("span", { className: "w-[32px] text-center" }, "Sun"),
    React.createElement("span", { className: "w-[32px] text-center" }, "Mon"),
    React.createElement("span", { className: "w-[32px] text-center" }, "Tue"),
    React.createElement("span", { className: "w-[32px] text-center" }, "Wed"),
    React.createElement("span", { className: "w-[32px] text-center" }, "Thu"),
    React.createElement("span", { className: "w-[32px] text-center" }, "Fri"),
    React.createElement("span", { className: "w-[32px] text-center" }, "Sat")));
export default Header;
//# sourceMappingURL=Header.js.map